'use strict'

import { Crossword } from './crossword.js'
import { Cell } from './grid.js'

export class PzlSvg extends Crossword {
  /**
   * Initialize the PZL SVG puzzle.
   *
   * @param data [Buffer] the puzzle as a Uint8Array buffer.
   */
  constructor (data = new Uint8Array()) {
    super(data)
  }

  get _ns () {
    return 'pzl'
  }

  _getAttrName (attr) {
    return this._ns + ':' + attr
  }

  /**
   * Convert the data to a manageable XML string.
   */
  _convertPuzzleToXML () {
    let str = new TextDecoder('utf-8').decode(this._data)

    if (str) {
      var parser = new DOMParser()
      const xml = parser.parseFromString(str, 'image/svg+xml')
      this._xml = xml.getElementsByTagName('svg')[0]
    }
  }

  // Parse the puzzle
  _parsePuzzle () {
    this._convertPuzzleToXML()

    this._setPuzzleData()
    this._setDims()
    this._setCells()

    return this
  }

  _setPuzzleData () {
    // Metadata
    let metadataAttrs = {
      'copyright': 'copyright',
      'creator': 'author',
      'notepad': 'notepad',
      'title': 'title'
    }

    let xwKey
    Object.keys(metadataAttrs).forEach(key => {
      xwKey = metadataAttrs[key]

      this[xwKey] = this._xml.getAttribute(this._getAttrName(key))
    })
  }

  // Sets the height/width of the puzzle.
  _setDims () {
    this.grid.height = parseInt(
      this._xml.getAttribute(this._getAttrName('grid_height'))
    )
    this.grid.width = parseInt(
      this._xml.getAttribute(this._getAttrName('grid_width'))
    )
  }

  // Set the puzzle key array
  _setCells () {
    let xmlCells = this._xml.getElementsByClassName('cell')

    let cells = []

    let cellNumber; let cellType; let isBlock

    let solution; let x; let y

    Array.from(xmlCells).forEach(cell => {
      solution = cell.getAttribute(this._getAttrName('cell_solution'))
      isBlock = solution === ''
      cellType = isBlock ? 'block' : ''

      x = parseInt(cell.getAttribute(this._getAttrName('x')))
      y = parseInt(cell.getAttribute(this._getAttrName('y')))
      cellNumber = cell.getAttribute(this._getAttrName('cell_clue_number'))

      cells.push(new Cell({
        'answer': (isBlock ? '' : solution),
        'cellType': cellType,
        'cellNumber': (cellNumber ? parseInt(cellNumber) : ''),
        'idx': this.grid.idxFromCoords(x, y),
        'x': x,
        'y': y
      }))
    })

    this.grid.cells = cells
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/pzl_svg.js
// module id = 240
// module chunks = 0